import { Editor, Transforms } from 'slate';
import { Align } from '../RichEditor.type';
import { getSelectionRootBlocks } from '../utils';

export const alignFn = (to?: Align) => (editor: Editor) => {
  const nodesInSelection = Array.from(
    Editor.nodes(editor, {
      match: (node) => !Editor.isEditor(node),
      at: getSelectionRootBlocks(editor),
    }),
  );
  const rootNodes = nodesInSelection.filter((el) => el[1].length === 1);
  const nodePathsToRemoveKey = nodesInSelection.map(([, path]) => path);
  const nodePathsToAddKey = rootNodes.map(([, path]) => path);
  nodePathsToRemoveKey.forEach((path) => Transforms.setNodes(editor, { 'text-align': undefined }, { at: path }));
  nodePathsToAddKey.forEach((path) => Transforms.setNodes(editor, { 'text-align': to }, { at: path }));
};
